import { useMotionValue } from 'framer-motion';
import { createContext, use, useEffect, useRef, useState } from 'react';

import { useEventCallback } from '../hooks/useEventCallback.ts';

const NavStateContext = createContext();
const NavSetContext = createContext();

export function NavContextProvider(props) {
  const prevWidthValue = useMotionValue(1);
  const widthValue = useMotionValue(1);

  const [navState, setState] = useState({
    prevWidth: 1,
    width: 1,
    collapsed: false,
    prevWidthValue,
    widthValue,
  });

  useEffect(() => {
    document.documentElement.style.setProperty('--width-left', `${widthValue.get()}px`);

    const unsubscribe = widthValue.onChange(() => {
      document.documentElement.style.setProperty('--width-left', `${widthValue.get()}px`);
    });

    return function () {
      unsubscribe();
    };
  }, [widthValue]);

  const setNavContextState = useEventCallback((key, width, collapsed) => {
    setState((prevState) => {
      // console.log(width);
      // console.log(localStorage.getItem(`layout.width.${key}`));

      const nextWidth =
        collapsed === true
          ? 1
          : key != null
            ? parseInt(localStorage.getItem('layout.width.sub-nav') ?? width ?? 1, 10)
            : (width ?? 1);

      prevWidthValue.set(widthValue.get());
      widthValue.set(nextWidth);

      document.documentElement.style.setProperty('--width-left', `${widthValue.get()}px`);

      return {
        ...prevState,
        prevWidth: prevWidthValue.get(),
        width: widthValue.get(),
        key: key,
        collapsed: collapsed === true,
      };
    });
  });

  const toggleNavCollapsed = useEventCallback(() => {
    setState((prevState) => {
      if (prevState.key == null) {
        return prevState;
      }

      const isCollapsed = !prevState.collapsed;

      prevWidthValue.set(widthValue.get());

      if (isCollapsed) {
        widthValue.set(1);
      } else {
        const savedWidth = parseInt(localStorage.getItem('layout.width.sub-nav') ?? '280', 10);
        widthValue.set(savedWidth);
      }

      document.documentElement.style.setProperty('--width-left', `${widthValue.get()}px`);

      return {
        ...prevState,
        prevWidth: prevWidthValue.get(),
        width: widthValue.get(),
        collapsed: isCollapsed,
      };
    });
  });

  const navSetValueRef = useRef();

  if (navSetValueRef.current == null) {
    navSetValueRef.current = {
      setNavContextState,
      toggleNavCollapsed,
    };
  }

  return (
    <NavSetContext.Provider value={navSetValueRef.current}>
      <NavStateContext.Provider value={navState}>{props.children}</NavStateContext.Provider>
    </NavSetContext.Provider>
  );
}

export function useSetNavContextState() {
  return use(NavSetContext);
}

export function useNavContextState() {
  return use(NavStateContext);
}
